module.exports = __webpack_public_path__ + "static/img/29.c05c475.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/29.png
// module id = JJMb
// module chunks = 3